var FeaturedListingType = {
  PROPERTY_OF_THE_WEEK: {
    name: 'PROPERTY_OF_THE_WEEK',
    description: 'Property of the Week'
  },
  FEATURED_PROPERTY: {
    name: 'FEATURED_PROPERTY',
    description: 'Featured Property'
  },
  TOP_SPOT: {
    name: 'TOP_SPOT',
    description: 'Top Spot'
  }
};
export default FeaturedListingType;